import { render, staticRenderFns } from "./ShotValDetail.vue?vue&type=template&id=5fbe3395&"
import script from "./ShotValDetail.vue?vue&type=script&lang=js&"
export * from "./ShotValDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShotValDetail.vue?vue&type=style&index=0&id=5fbe3395&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports